import { motion } from "framer-motion";
import { MouseEvent } from "react";

import cn from "@/helpers/classNames";
import { Link, useMatchRoute } from "@tanstack/react-location";

export type Tab = {
  href?: string;
  name: string;
  id: string;
  current?: boolean;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
};

export default function Tabs({
  tabs,
  action: Action,
  className,
}: {
  tabs: Tab[];
  action?: JSX.Element;
  className?: string;
}) {
  const matchRoute = useMatchRoute();

  function isSelected(currentPath: string | undefined) {
    if (currentPath === undefined) return false;
    return matchRoute({ to: currentPath });
  }

  return (
    <div className={cn("mb-4 flex h-12 items-center space-x-8", className)}>
      <div className="grow">
        <nav className="flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className={cn(
                "relative cursor-pointer text-sm font-medium hover:text-blue-500",
                {
                  "cursor-default text-blue-500": isSelected(tab.href),
                },
              )}
              aria-current={tab.current ? "page" : undefined}
              onClick={tab.onClick}
            >
              {tab.name}
              {isSelected(tab.href) && (
                <motion.div
                  className="absolute -bottom-[2px] left-0 right-0 h-[2px] rounded-full bg-blue-500"
                  layoutId="sub-page-tabs"
                />
              )}
            </Link>
          ))}
        </nav>
      </div>
      {Action && <div className="shrink-0">{Action}</div>}
    </div>
  );
}
